'use client';
import { forwardRef as forwardRef$1 } from 'react';

function forwardRef(component) {
  return forwardRef$1(component);
}

export { forwardRef };
